module.exports = __webpack_public_path__ + "img/20191115130730820.bb4a3a74.jpg";